export default __webpack_public_path__ + "static/artifakt-element-italic-24ddc286ccb03fdb5bcd6a385633076a.woff2";